function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
import PropTypes from "prop-types";
var SvgDirecao = function SvgDirecao(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M19.194 26.829a.5.5 0 01-.646-.479v-4.302a.5.5 0 01.271-.445 6.463 6.463 0 003.215-3.835.5.5 0 01.478-.353h4.115a.5.5 0 01.492.593 11.486 11.486 0 01-7.925 8.82zm6.811-8.414h-3.134a7.467 7.467 0 01-3.323 3.93v3.307a10.495 10.495 0 006.457-7.237zM13.194 26.35a.5.5 0 01-.646.479 11.486 11.486 0 01-7.925-8.82.5.5 0 01.491-.594H9.23a.5.5 0 01.478.353 6.462 6.462 0 003.215 3.835.5.5 0 01.27.445v4.302zm-1-4.004a7.465 7.465 0 01-3.324-3.93H5.736a10.495 10.495 0 006.458 7.236v-3.306zM15.87 4.42c5.517 0 10.23 3.95 11.248 9.314a.5.5 0 01-.492.593H22.29a.5.5 0 01-.37-.164c-1.124-1.237-3.447-2.058-6.048-2.058s-4.925.821-6.048 2.058a.5.5 0 01-.37.164H5.114a.5.5 0 01-.49-.593C5.64 8.37 10.353 4.42 15.87 4.42zm0 1c-4.828 0-8.984 3.318-10.135 7.907H9.24c1.374-1.373 3.879-2.222 6.632-2.222 2.753 0 5.257.849 6.632 2.222h3.503c-1.15-4.59-5.307-7.907-10.135-7.907zm0-3.92c7.937 0 14.37 6.434 14.37 14.371s-6.433 14.37-14.37 14.37c-7.937 0-14.371-6.433-14.371-14.37C1.5 7.934 7.934 1.5 15.87 1.5zm0 1C8.486 2.5 2.5 8.487 2.5 15.871s5.986 13.37 13.37 13.37c7.385 0 13.372-5.986 13.372-13.37C29.242 8.486 23.255 2.5 15.87 2.5zm-2.345 14.704a.5.5 0 110-1h4.69a.5.5 0 010 1h-4.69z"
  }));
};
SvgDirecao.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgDirecao.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgDirecao;